/*
 * hyperion-index:begin
 * ---
 * path: hyperion-cloud/web/src/platform/design-system/components/ui/Checkbox.tsx
 * layer: web
 * area: components
 * kind: component
 * web_root: components
 * relpath: web/src/platform/design-system/components/ui/Checkbox.tsx
 * filename: Checkbox.tsx
 * extension: tsx
 * ---
 * hyperion-index:end
 */

import { InputHTMLAttributes } from 'react';
import { clsx } from 'clsx';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  onCheckedChange?: (checked: boolean) => void;
}

export const Checkbox = (
  { className, checked, onCheckedChange, onChange, ref, ...props }: CheckboxProps & { ref?: React.Ref<HTMLInputElement> }
) => (
  <input
    {...props}
    aria-hidden={false}
    tabIndex={0}
    data-uix-control="checkbox"
    role="checkbox"
    type="checkbox"
    ref={ref}
    checked={checked}
    onChange={(e) => {
      onChange?.(e);
      onCheckedChange?.(e.target.checked);
    }}
    className={clsx(
      'h-4 w-4 rounded border-[rgb(var(--color-border))] text-accent-text focus:ring-accent-ring focus:ring-2 focus:ring-offset-0',
      'cursor-pointer transition-colors',
      className
    )}
  />
);
